import EventEmitter from '../helpers/EventEmmiter';
const template = require('./index.html');
import initInfoSwiper from '../swiper';

require('./style.scss');

class E3Sidebar extends EventEmitter {
    _wrapper = null;
    _container = null;
    _contentNode = null;
    _closeButton = null;
    _options = {
        getInfoPoi: null,
        parseInfoContainer: null
    };

    _cache = '';

    _handlers = {};
    _headerTitle = null;
    _hotspots = [];
    _current = null;

    constructor(wrapper, options = {}, translationService){
        super();

        this._wrapper = wrapper;
        this._translationService = translationService;

        this._prepareOptions(options);
        this._init();
    }

    addHotspot(hotspots) {
        this._hotspots = [];
        
        hotspots
            .filter(({poiID}) => poiID)
            .sort((a, b) => a.order - b.order)
            .forEach((hotspot, ind) => {
                this._hotspots.push({
                    order: hotspot.order || ind + 1,
                    ...hotspot
                });
            }); 
    }

    async append(hotspotUrl) {
        const current = this._hotspots.find(({htmlURL}) => htmlURL === hotspotUrl);
        let html = await this._options.getInfoPoi(current.htmlURL);
        html = this._options.parseInfoContainer(html);

        const title = current.title;
        if(title) html = `<p class="e3-sidebar--wrapper__title"><b>${title}</b></p> ${html}`;
        this._contentNode.innerHTML = html;
        this._setHeader(current.order);
        this._current = current;
        this._toggleActive(`.info-${this._current.poiID}`, 'add');
        initInfoSwiper(this._contentNode.querySelectorAll('.swiper-container'));
    }

    removeActive(info) {
        if(!this.isShown()) {
            info.classList.remove('active');
        }
    }

    _initHeader() {
        this._headerTitle = this._wrapper.querySelector('.e3-sidebar--panel__body');
    }

    _setHeader(current) {
        this._headerTitle.textContent = `${current} of ${this._hotspots.length}`;
    }

    _prepareOptions(options) {
        Object.keys(this._options).forEach((key) => {
            if (options.hasOwnProperty(key)) this._options[key] = options[key];
        });
    }

    _audioInfoListener() {
        this._contentNode.querySelectorAll('audio')
            .forEach((audio) => {
                audio.currentTime = 0;
                audio.pause();
            });
    }

    _init() {
        let container = document.createElement('div');
        container.classList.add('e3-sidebar');
        container.classList.add('hidden');
        this._wrapper.appendChild(container);
        container.innerHTML = template;
        this._closeButton = container.querySelector('.e3-sidebar--close');
        this._contentNode = container.querySelector('.e3-sidebar--wrapper');
        this._container = container;
        this._nav = {
            left: {
                element: this._wrapper.querySelector('.e3-sidebar--panel__left'),
                handler: this._onChangeHotspot.bind(this, 'left')
            },
            right: {
                element: this._wrapper.querySelector('.e3-sidebar--panel__right'),
                handler: this._onChangeHotspot.bind(this, 'right')
            },
        }

        this._bindEvents();
        this._initHeader();
    }

    _onOutboxClick(e) {
       if(e && this._wrapper.contains(e.target)) return ;

        this._hide();
    }

    _removeAllActive() {
        this._hotspots.forEach((hotspot) => {
            this._toggleActive(`.info-${hotspot.poiID}`, 'remove')
        })
    }

    _bindEvents() {
        let close = this._closeButton;
        let closeHandler = () => {
            this._fireEvent('close.fullscreen.info');
            this._hide();
        } 

        this._handlers.close = {
            element: close,
            handler: closeHandler
        };
        this._onOutboxClickListener = (e) => {
            // e.preventDefault();
            // e.stopPropagation();
            // TODO: comment because blocked close info

            this._onOutboxClick(e);
        } 

        this._wrapper.addEventListener('mousedown',  this._onOutboxClickListener);
        this._wrapper.addEventListener('touchstart',  this._onOutboxClickListener);

        for(let i in this._nav){
            this._nav[i].element.addEventListener('click', this._nav[i].handler);
        }
        
        close.addEventListener('click', closeHandler);
    }

    async _onChangeHotspot(next, e) {
        e.preventDefault();
        e.stopPropagation();

        const nextSlide = next == 'right';
        let order = nextSlide ? +this._current.order + 1 : +this._current.order - 1;
        if(order >= this._hotspots.length + 1) order = 1;
        if(order < 1) order = this._hotspots.length;
        
        this._removeAllActive();
        const hotspot = this._hotspots.find((hotspot) => hotspot.order == order);
        await this.append(hotspot.htmlURL);
        
        this._fireEvent('move-scene', hotspot);
    }

    _toggleActive(selector, type) {
        this._wrapper.querySelector(selector)?.classList[type]('active');
    }

    _unbindEvents() {
        Object.keys(this._handlers).forEach((key) => {
            let element = this._handlers[key].element;
            let handler = this._handlers[key].handler;

            element.removeEventListener('click', handler);

            delete this._handlers[key];
        });

        this._wrapper.removeEventListener('mousedown',  this._onOutboxClickListener);
        this._wrapper.removeEventListener('touchstart',  this._onOutboxClickListener);

        for(let i in this._nav){
            this._nav[i].element.removeEventListener('click', this._nav[i].handler);
        }
    }

    _show() {
        this._container.classList.remove('hidden');
    }

    _hide() {
        this._audioInfoListener();
        this._container.classList.add('hidden');
        this._removeAllActive();
        
        // if (this._current) this._fireEvent('close.fullscreen.info');
    }

    show() {
        this._show();
    }

    hide(e) {
        if (e?.target.closest('.e3-sidebar')) return ;

        this._hide();
    }

    getContent() {
        return this._contentNode.innerHTML;
    }

    isShown() {
        return !this._container.classList.contains('hidden');
    }

    destroy() {
        if (!this._current) return ;

        this._unbindEvents();
        this._removeAllActive();

        this._wrapper.removeChild(this._container);
    }
}

export default E3Sidebar;
